package link.erpango.quip.domain.services

import link.erpango.quip.domain.entities.DMaintenance
import link.erpango.quip.domain.entities.DSparePart
import link.erpango.quip.domain.entities.DVehicle
import org.kotlincrypto.hash.sha2.SHA256

object SignatureService {

    @OptIn(ExperimentalStdlibApi::class)
    private fun hash(input: String): String {
        val digest = SHA256()
        digest.update(input.encodeToByteArray())
        return digest.digest().toHexString()
    }

    fun signVehicle(vehicle: DVehicle): String {
        // Only immutable identifying info: VIN, Brand, Model, Year
        // Note: Creation date is not available in DVehicle, so we skip it.
        val dataToSign = "${vehicle.vin}|${vehicle.brand}|${vehicle.model}|${vehicle.year}"
        return hash(dataToSign)
    }

    fun signMaintenance(maintenance: DMaintenance, previousSignature: String? = null): String {
        // Chain signing: include previous signature if available
        val dataToSign = "${maintenance.vehicleVin}|${maintenance.kilometers}|${maintenance.mechanic}|${maintenance.workshop}|${maintenance.description}|${maintenance.date}|${maintenance.cost}|${previousSignature ?: ""}"
        return hash(dataToSign)
    }

    fun signSparePart(sparePart: DSparePart): String {
        val dataToSign = "${sparePart.categoryId}|${sparePart.sparePartId}|${sparePart.brand}|${sparePart.model}|${sparePart.additionalInfo}|${sparePart.durabilityDays}|${sparePart.quantity}|${sparePart.unit}"
        return hash(dataToSign)
    }
}
